import angular from 'angular';
import constants from 'app/constants';
import {
  oversightDataService,
  oversightSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
// import editFindingCommentDialog from '../dialog.editFindingCommentDialog';
import controller from './agendaItem-comment.controller';
import directive from './agendaItem-comment.directive';


export default angular.module('app.components.advisory.oversight.agendaItemComment', [
  alerts,
  oversightDataService,
  oversightSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('agendaItemComment', directive)
  .controller('AgendaItemCommentController', controller)
  .name;

console.log('app.components.advisory.oversight.agendaItemComment created');
